import type Result from 'true-myth/result';

import type { ValidatingHttpFetcherWithBaseUrl } from '~/shared/validating-http-fetcher';

import type { CompanyProfile } from './company-profile';
import { companyProfileSchema } from './company-profile';

export type GenerateCompanyDescription = () => Promise<Result<CompanyProfile, unknown>>;

const timeout = 60_000;

export const createGenerateCompanyDescription = (dependencies: {
    readonly validatingCobrainerApiFetcher: ValidatingHttpFetcherWithBaseUrl;
}): GenerateCompanyDescription => {
    const { validatingCobrainerApiFetcher } = dependencies;

    return () => {
        return validatingCobrainerApiFetcher.post(companyProfileSchema, {
            pathname: `/company-profile/generate/description`,
            requestOptions: {
                timeout,
            },
        });
    };
};
